import ChartAvgTimeByTechStack from './ChartAvgTimeByTechStack.container';

export default ChartAvgTimeByTechStack;
